"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientContext = void 0;
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
exports.ClientContext = (0, react_1.createContext)({
    axios: axios_1.default,
    isSessionExpired: false,
    setIsSessionExpired: () => { },
    authStorage: null,
    hasPermissionChanged: false,
    setHasPermissionChanged: () => { },
});
